import { render, staticRenderFns } from "./ClientLinkBranch.vue?vue&type=template&id=611e1059&scoped=true&"
import script from "./ClientLinkBranch.vue?vue&type=script&lang=js&"
export * from "./ClientLinkBranch.vue?vue&type=script&lang=js&"
import style0 from "./ClientLinkBranch.vue?vue&type=style&index=0&id=611e1059&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611e1059",
  null
  
)

export default component.exports